import React, { useState } from 'react';
import style from './sidebarGuideComp.module.scss';
import { ContentCompany, ContentProduct } from '@web-edm/send/contentRoot';
import { ReactComponent as QuestionIcon } from '@/images/icons/edm/yingxiao/selectTask/select-task-question.svg';
import { ReactComponent as QuestionMark } from '@/images/icons/edm/yingxiao/selectTask/select-task-question-mark.svg';
import { ReactComponent as EditorUseSkillIcon } from '@/images/icons/edm/editor-use-skill.svg';
import { ReactComponent as CloseIcon } from '@/images/icons/edm/yingxiao/edm-editor-close.svg';
import { ReactComponent as OpenIcon } from '@/images/icons/edm/yingxiao/edm-editor-open.svg';
export const SidebarGuideCompment = props => {
    const { type, setOnOpen } = props;
    const [close, setClose] = useState(false);
    const ProductDataSource = {
        question: {
            title: '为什么要在营销物料中增加商品？',
            answer: [
                {
                    content: '通过在营销物料中加入商品展示，您可以有效地吸引客户的注意，传递产品信息，促进销售，提高品牌认知，并实现个性化的营销，从而增强营销效果：',
                    list: [
                        '产品展示：展示产品或服务，吸引潜客的注意并引起兴趣。',
                        '信息传递：传递产品特点、功能和优势的信息，加深客户理解。',
                        '促进销售：引导客户点击物料中的商品链接，可以直接促进销售，增加转化率，从而提高营销效果。',
                    ],
                },
                {
                    content: ['提高品牌认知：更加熟悉您的产品线，从而增强品牌忠诚度。'],
                },
                {
                    content: ['个性化推荐：根据客户的购买历史和兴趣，通过物料中的商品展示，可以实现个性化的推荐，提高购买可能性。'],
                },
            ],
        },
        skill: {
            title: '商品使用小技巧',
            list: [
                '突出特色商品',
                '强调核心买点和价值',
                '强调个性化，确保符合客户的偏好',
                '引导用户的提示，如：立即购买、了解更多',
                '保证链接正确无误',
                '物料和商品展示应兼容各种设备，请提前测试',
                '通过工具分析落地页的转化率，用户行为等关键指标',
            ],
        },
    };
    const CompanyDataSource = {
        question: {
            title: '为什么要在营销物料中增加落地页？',
            answer: [
                {
                    content: '在客户沟通中，插入营销落地页能为您的营销活动增添：',
                    list: ['更多的交互性。', '提供更多的信息。', '增加转化机会。'],
                },
                {
                    content: [
                        '落地页可以成为您营销物料的信息扩展，通过提供更详细的信息、特别优惠或者个性化的内容，吸引读者点击并且参与互动、填写表单、购买等行为。因此，合理的将落地页融入您的营销物料中，将有效提高客户参与度，加强品牌印象，从而为公司的宣传活动带来更大的成功。',
                    ],
                },
            ],
        },
        skill: {
            title: '落地页使用小技巧',
            list: [
                '确保物料和落地页风格一致',
                '优化落地页在移动端的体验',
                '突出引导性，通过突出的按钮等引导用户向某一方向前进',
                '内容简洁明了且具有吸引力',
                '可以通过A/B测试来优化落地页，保证最佳的转化率',
                '通过工具分析落地页的转化率，用户行为等关键指标',
            ],
        },
    };
    const ContentProductComp = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: style.questionTop },
                React.createElement(QuestionIcon, { className: style.questionIcon }),
                React.createElement("div", { className: style.questionTitle }, ProductDataSource.question.title)),
            ProductDataSource.question.answer.map(item => {
                var _a;
                return (React.createElement("div", { className: style.questionAnswer },
                    React.createElement(QuestionMark, { className: style.questionContentItemMark }),
                    React.createElement("div", { className: style.questionAnswerTitle }, item.content),
                    item.list && ((_a = item.list) === null || _a === void 0 ? void 0 : _a.length) > 0 && (React.createElement(React.Fragment, null, item.list.map(item => {
                        return React.createElement("li", { className: style.questionAnswerTitle }, item);
                    })))));
            })));
    };
    const ContentCompanyComp = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: style.questionTop },
                React.createElement(QuestionIcon, { className: style.questionIcon }),
                React.createElement("div", { className: style.questionTitle }, CompanyDataSource.question.title)),
            CompanyDataSource.question.answer.map(item => {
                var _a;
                return (React.createElement("div", { className: style.questionAnswer },
                    React.createElement(QuestionMark, { className: style.questionContentItemMark }),
                    React.createElement("div", { className: style.questionAnswerTitle }, item.content),
                    item.list && ((_a = item.list) === null || _a === void 0 ? void 0 : _a.length) > 0 && (React.createElement(React.Fragment, null, item.list.map(item => {
                        return React.createElement("li", { className: style.questionAnswerTitle }, item);
                    })))));
            })));
    };
    const SkillComp = () => {
        let object = type === ContentProduct ? ProductDataSource : CompanyDataSource;
        return (React.createElement("div", { className: style.skill },
            React.createElement("div", { className: style.questionTop, style: { marginTop: 20 } },
                React.createElement(EditorUseSkillIcon, { className: style.useSikllIcon }),
                React.createElement("div", { className: style.questionTitle }, object.skill.title)),
            React.createElement("div", { className: style.skillList }, object.skill.list.map((item, index) => {
                return (React.createElement("div", { className: style.skillItem },
                    React.createElement("div", { className: style.skillNumber }, index + 1),
                    React.createElement("div", { className: style.skillText }, item)));
            }))));
    };
    const onClickState = () => {
        setOnOpen && setOnOpen(close);
        setClose(!close);
    };
    const StateOpComp = () => {
        return (React.createElement("div", { className: style.opIcon, onClick: onClickState },
            !close && React.createElement(CloseIcon, null),
            close && React.createElement(OpenIcon, null)));
    };
    return (React.createElement("div", { className: style.root },
        React.createElement("div", { className: style.content, style: { display: close ? 'none' : 'block', width: '288px' } },
            React.createElement("div", { className: style.question },
                type === ContentProduct && ContentProductComp(),
                type === ContentCompany && ContentCompanyComp()),
            SkillComp()),
        StateOpComp()));
};
